import { LinkPlugin as LexicalLinkPlugin } from '@lexical/react/LexicalLinkPlugin'
import React, { FC } from 'react'

import { validateUrl } from '../../utils/url'

/**
 * Link plugin from lexical library with our custom validate url function
 */
export const LinkPlugin: FC = () => {
  return <LexicalLinkPlugin validateUrl={validateUrl} />
}
